 <div class="columns has-background-white">
  <div class="column custom-box p-3 removeY" *ngIf="itineraryHistory">
    <div class="column custom-box has-background-white p-3">
      <div class="container">
        <code [innerHTML]="itineraryHistory"></code>
      </div>
    </div>
  </div>
</div>
